import { useTranslation } from '@sib/i18n';
import { UserAvatar } from '@sib/ui';
import { useCopyToClipboard } from '../hooks/use-copy-to-clipboard';
import { Tooltip } from './Tooltip';

interface PersonProps {
  email?: string | null;
  avatarUrl?: string | null;
  name?: string;
}

export const Person = ({ avatarUrl, name, email }: PersonProps) => {
  const { t } = useTranslation();
  const { handleCopy } = useCopyToClipboard();

  const content = (
    <>
      <UserAvatar
        variant="small"
        avatarImageProps={{
          avatarUrl,
        }}
        avatarFallbackProps={{ name }}
        className="size-6"
      />
      <div className="flex w-full flex-col gap-0.5">
        <span className="text-muted-foreground text-sm">{name}</span>
        <span className="text-muted-foreground truncate text-xs">{email}</span>
      </div>
    </>
  );

  if (!email) return <div className="flex items-center gap-1.5">{content}</div>;

  const tooltip = t('copyToClipboardTooltip', { text: 'e-mail' });

  return (
    <Tooltip content={tooltip} TooltipTriggerProps={{ asChild: true }}>
      <button
        type="button"
        className="flex w-full cursor-pointer items-center gap-1.5 text-left"
        onClick={event => {
          event.stopPropagation();
          handleCopy(email);
        }}
        aria-label={tooltip}
      >
        {content}
      </button>
    </Tooltip>
  );
};
